export const getAuthorUrl = id => `https://artmetadata.io/artists/${id}/artist`;
export const searchAuthorAllLotsURL = id => `/cleaning-lots/cleaning-ui?artistId=${id}`;
export const searchAuthorPublishedLotsURL = id => `/cleaning-lots/cleaning-ui?artistId=${id}&lotsStatus=published`;
export const getUlanUrl = id => `https://www.getty.edu/vow/ULANFullDisplay?find=&role=&nation=&prev_page=&subjectid=${id}`;
export const getUlanUrlSearch = searchText => `https://www.getty.edu/vow/ULANServlet?english=Y&find=${searchText}&role=&page=1&nation=`;
